// extracted by mini-css-extract-plugin
export default {"page-title-bar":"Q4lnW2PrzI51ozoRwRd2","container":"GxNcXZlKY5PuzRQxvyQg"};